import { LineStyle, PolygonPlaneMeshProps } from '@editor/interfaces/canvas'

import { PlaneData } from './store'

export const WORKING_STYLES = {
  transparent: true,
  opacity: 0.4,
  depthTest: false,
  depthWrite: false,
  renderOrder: 998,
}

/**
 * Get styles for a non-saved plane.
 *
 * @param plane Plane Data
 * @param hoveredElementId Currently hovered element ID
 * @param selectedElementIds Array of selected element IDs
 */
export const getNonSavedPlaneStyles = (
  plane: PlaneData,
  isHovered: boolean,
  isSaving: boolean,
  selectedElementIds: string[],
  hiddenElementIds: string[],
): Partial<PolygonPlaneMeshProps> => {
  const isSelected = selectedElementIds.includes(plane.id)
  const styles: Partial<PolygonPlaneMeshProps> = {
    ...WORKING_STYLES,
    color: '#ffffff',
    visible: !hiddenElementIds.includes(plane.id),
  }

  if (isSaving) {
    styles.guideLine = {
      color: '#000000',
      style: LineStyle.Dashed,
    }
  } else if (isHovered) {
    styles.guideLine = {
      color: 'yellow',
    }
  } else if (!isSelected) {
    styles.guideLine = {
      color: '#ffffff',
    }
  }

  return styles
}
